import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { useNavigate, useParams } from 'react-router-dom';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';
import { approvalsCount, fetchApprovals } from './supApprovalsFun/fetchApprovals';

const ApprovalsList = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [approvalsData, setApprovalsData] = useState([]);
    const [offSet, setOffSet] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [selectedType, setSelectedType] = useState('trip');
    const [totalCount, setTotalCount] = useState(0);

    const limit = 10;
    const { mode } = useParams();

    const totalData = totalCount;

    const tableHeader = ['Package Name', 'Organizer', 'Type', 'Duration', 'Difficulty', 'Start City / Price', 'Status'];

    useEffect(() => {
        if (!selectedType) return;

        const fetchApprovalData = async () => {
            fetchApprovals(setApprovalsData, setLoading, limit, offSet, selectedType);
        };

        fetchApprovalData();

        // eslint-disable-next-line
    }, [selectedType, limit, offSet]);

    useEffect(() => {
        approvalsCount(setTotalCount, selectedType, setLoading);

        // eslint-disable-next-line
    }, [selectedType]);

    const getPrice = (price) => {
        if (!Array.isArray(price)) {
            return 'N/A';
        }

        const priceDetails = price.map((item) => {
            return `${item?.startCity ?? 'N/A'} - ${item?.price ?? '0'}`;
        });

        return priceDetails.join(', ');
    };

    /*
     * Camp / Accommodation helpers
     */

    const getCampOrganizer = (row) => {
        return row?.host?.organizerName || row?.host?.name || row?.organizerName || 'N/A';
    };

    const getCampType = (row) => {
        return row?.propertyType || row?.propertyCategory || 'N/A';
    };

    const getCampLocation = (row) => {
        return row?.address?.city || row?.address?.state || 'N/A';
    };

    const getCampPrice = (row) => {
        const firstUnit = row?.units?.[0];

        const firstPricing = firstUnit?.pricing?.[0];

        if (!firstPricing) {
            return 'N/A';
        }

        const price = firstPricing?.actualPrice ?? firstPricing?.basePrice ?? 0;

        return `₹${price}`;
    };

    const getCampUnitCount = (row) => {
        if (!Array.isArray(row?.units)) {
            return 0;
        }

        return row.units.length;
    };

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const isCamp = selectedType === 'camp';

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}

            <div className='supFilter'>
                <h1 className='supportHeader'>Approvals</h1>

                <div>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={selectedType}
                        onChange={(e) => {
                            setSelectedType(e.target.value);
                            setOffSet(0);
                            setPageNumber(1);
                        }}
                        style={{ marginRight: '8px' }}
                    >
                        <option value='trip'>Trip</option>
                        <option value='camp'>Camp</option>
                        <option value='guide'>Guide</option>
                        <option value='act'>Activity</option>
                    </select>
                </div>
            </div>

            <div className='table-top-container'>
                {approvalsData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return (
                                            <th key={headIndex}>
                                                {isCamp && headIndex === 0
                                                    ? 'Camp Name'
                                                    : isCamp && headIndex === 3
                                                      ? 'Units'
                                                      : isCamp && headIndex === 4
                                                        ? 'Property'
                                                        : isCamp && headIndex === 5
                                                          ? 'Location / Price'
                                                          : head}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>

                            <tbody>
                                {approvalsData?.map((row) => {
                                    return (
                                        <tr
                                            key={row._id}
                                            className='tableBodyRow allowCLick'
                                            onClick={() =>
                                                navigate(`/support/${mode}/approvals/details/${row._id}`, {
                                                    state: {
                                                        selectedType,
                                                        id: row._id
                                                    }
                                                })
                                            }
                                        >
                                            {/* Name */}
                                            <td>{row?.title ?? 'N/A'}</td>

                                            {/* Organizer */}
                                            <td>{isCamp ? getCampOrganizer(row) : (row?.organizerName ?? 'N/A')}</td>

                                            {/* Type */}
                                            <td>
                                                {isCamp
                                                    ? getCampType(row)
                                                    : Array.isArray(row?.quickView?.type)
                                                      ? row.quickView.type.join(', ')
                                                      : (row?.quickView?.type ?? 'N/A')}
                                            </td>

                                            {/* Duration / Units */}
                                            <td>
                                                {isCamp ? getCampUnitCount(row) : (row?.quickView?.duration ?? 'N/A')}
                                            </td>

                                            {/* Difficulty / Property */}
                                            <td>
                                                {isCamp
                                                    ? (row?.propertyCategory ?? row?.propertyType ?? 'N/A')
                                                    : (row?.quickView?.difficulty ?? 'N/A')}
                                            </td>

                                            {/* Price */}
                                            <td>
                                                {isCamp
                                                    ? `${getCampLocation(row)} / ${getCampPrice(row)}`
                                                    : getPrice(row.price)}
                                            </td>

                                            {/* Status */}
                                            <td>{row?.status ?? 'N/A'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {/* Mobile */}

                        <div className='responsiveCardContainer'>
                            {approvalsData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{isCamp ? 'Camp Name' : tableHeader[0]}:</strong>{' '}
                                            {row?.title ?? 'N/A'}
                                        </p>

                                        <p>
                                            <strong>{tableHeader[1]}:</strong>{' '}
                                            {isCamp ? getCampOrganizer(row) : (row?.organizerName ?? 'N/A')}
                                        </p>

                                        <p>
                                            <strong>{tableHeader[2]}:</strong>{' '}
                                            {isCamp
                                                ? getCampType(row)
                                                : Array.isArray(row?.quickView?.type)
                                                  ? row.quickView.type[0]
                                                  : 'N/A'}
                                        </p>

                                        <p>
                                            <strong>{isCamp ? 'Units' : tableHeader[3]}:</strong>{' '}
                                            {isCamp ? getCampUnitCount(row) : (row?.quickView?.duration ?? 'N/A')}
                                        </p>

                                        <p>
                                            <strong>{isCamp ? 'Property' : tableHeader[4]}:</strong>{' '}
                                            {isCamp
                                                ? (row?.propertyCategory ?? row?.propertyType ?? 'N/A')
                                                : (row?.quickView?.difficulty ?? 'N/A')}
                                        </p>

                                        <p>
                                            <strong>{isCamp ? 'Location / Price' : tableHeader[5]}:</strong>{' '}
                                            {isCamp
                                                ? `${getCampLocation(row)} / ${getCampPrice(row)}`
                                                : getPrice(row.price)}
                                        </p>

                                        <p>
                                            <strong>{tableHeader[6]}:</strong> {row?.status ?? 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
            </div>
        </>
    );
};

export default ApprovalsList;
